import React, { useEffect } from 'react';
import { useDialogStore } from '../stores/dialogStore';

const Dialog = () => {
  const { isOpen, type, title, message, confirmText, cancelText, onConfirm, onCancel, close } = useDialogStore();

  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        if (type === 'confirm' && onCancel) {
          onCancel();
        } else if (type === 'alert' && onConfirm) {
          onConfirm();
        }
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, type, onConfirm, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      {/* Dialog backdrop - click to close for alerts */}
      <div
        className="absolute inset-0"
        onClick={() => {
          if (type === 'alert' && onConfirm) {
            onConfirm();
          }
        }}
      />

      {/* Dialog content */}
      <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn">
        {/* Title */}
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {title}
        </h3>

        {/* Message */}
        <div className="text-sm text-gray-700 dark:text-gray-300 mb-6">
          {message}
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          {type === 'confirm' && onCancel && (
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            >
              {cancelText}
            </button>
          )}
          {onConfirm && (
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors"
              autoFocus
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dialog;
